import { render, staticRenderFns } from "./PassagesListArticle.vue?vue&type=template&id=09a4341a&"
import script from "./PassagesListArticle.vue?vue&type=script&lang=js&"
export * from "./PassagesListArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports